// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperTitle-cls1_Sli","cls2":"PaperTitle-cls2_kzI PaperTitle-cls1_Sli"};